import React  from 'react';
import { TableQuestionsCategory } from '../../components';

const QuestionsCategory = () => {

  return (
    <div>
      <div className="m-2 md:m-10 p-2 md:p-6 bg-white rounded-3xl">
        <p className="text-xl mb-4 text-left">Lista Pyetjet me kategori</p>
        <TableQuestionsCategory/>
      </div>
    </div>
  );
};

export default QuestionsCategory;